import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import {CampoSimNao} from '../../../components/processo/CamposProcesso.jsx';

/* Subaba "Opções" da aba Inscrição: as opções Sim/Não, que valem para todos os programas. */
export default function TabInscricaoOpcoes({control, errors}) {
    const props = {control, errors};

    return (
        <Grid container spacing={3}>
            <CampoSimNao {...props} nome='disponivelParaFuncionario' rotulo='Disponibilizar para funcionários?'/>
            <CampoSimNao {...props} nome='flagRevalidacao' rotulo='Processo Seletivo de revalidação *'/>
            <CampoSimNao {...props} nome='flagSomenteInscricaoComCargas' rotulo='Somente inscrições com carga *'/>
            <CampoSimNao {...props} nome='flagProtocoloEntrega' rotulo='Exigir protocolo de entrega de documentos *'/>
        </Grid>
    );
}

TabInscricaoOpcoes.propTypes = {
    control: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired
};
